<script>
	/*
		TCareTextArea.svelte
	*/

	export let source;
	export let prop;
	export let setValue;
	export let placeholder;
	
	const _onKeyUp = (e) => {
		setValue(source, prop, e.target.value);
	}

</script>

<style>
</style>

<div class="tcui-control flex-row">
	<textarea class="text-area" value={source[prop]} on:keyup={_onKeyUp} placeholder={placeholder}/>
</div>

